import { Component, type ErrorInfo, type ReactNode } from 'react'

// Minimal error boundary to keep dashboard routes from blanking the page.
class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, { hasError: boolean }> {
  constructor(props: { children: ReactNode; fallback?: ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error', error, info)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback
      return (
        <section className="error-boundary">
          <h2>Something went wrong</h2>
          <p>Try reloading the page or returning to the dashboard.</p>
        </section>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
